import { apiWrapper } from "@/services/api";

export const validFrameWithCode = async (id, emergency_code) => {
  try {
    await apiWrapper(
      "PUT",
      `frames/${id}/emergency_code?code=${emergency_code}`
    );
  } catch (err) {
    console.log("ERROR!! validFrameWithCode()");
    throw err;
  }
};
